<template>
  <v-container
    class="color"
    grid-list-lg
  >
    <v-row
      class="mt-3"
    >
      <!-- onboarding if no elements START -->
      <template v-if="showOnBoarding">
        <v-col cols="12">
          <v-card
            height="100%"
            color="white"
          >
            <onboarding-api />
          </v-card>
        </v-col>
      </template>
      <!-- onboarding if no elements END -->

      <!-- add card START -->
      <template>
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="4"
        >
          <add-card
            v-if="showOnBoarding || listItems.length>0"
            :type="'api'"
          />
        </v-col>
      </template>
      <!-- add card END -->

      <!-- API cards START -->
      <template v-if="!showOnBoarding">
        <v-col
          v-for="item in listItems"
          :key="item.id"
          cols="12"
          sm="6"
          md="4"
          lg="4"
        >
          <api-card :api="item" />
        </v-col>
        <!-- load data on scroll START -->
        <mugen-scroll
          :handler="fetchData"
          :should-handle="!newElementsLoading"
        >
          <template v-if="nextPage!==null">
            Loading new elements...
          </template>
        </mugen-scroll>
        <!-- load data on scroll END -->
      </template>
      <!-- API cards END -->
    </v-row>
  </v-container>
</template>

<script>
  import ApiCard from '../../../UIComponents/Cards/ApiCard.vue'
  import AddCard from '../../../UIComponents/Cards/AddCard.vue'
  import MugenScroll from 'vue-mugen-scroll'
  import OnboardingApi from '../../../UIComponents/Onboarding/OnboardingApi.vue'
  import ApiService from './services/ApiService'

  export default {
    components: {
      ApiCard,
      MugenScroll,
      OnboardingApi,
      AddCard,
    },
    data: function () {
      return {
        loading: false,
        showOnBoarding: false,
        newElementsLoading: false,
        listItems: [],
        nextPage: null,
        callNumber: 0,
      }
    },
    mounted: function () {
      // callNumber is used to determine how many times we called the backend to know
      // which page we are on.
      this.callNumber++
      var t = this
      this.loading = true
      ApiService.list(this, 0).then(function (response) {
        if (response.data.results.length) {
          t.listItems = response.data.results
        } else {
          t.showOnBoarding = true
        }
        if (response.data.next !== null) {
          t.nextPage = response.data.next
        } else {
          t.nextPage = null
        }
        t.loading = false
      }).catch(function (error) {
        t.$store.commit('push', { msg: error, color: 'error' })
        t.loading = false
        t.showOnBoarding = true
      })
    },
    methods: {
      // fetchData is called when you want to load additional elements by making a call to the back
      fetchData () {
        this.newElementsLoading = true
        var t = this
        if (t.nextPage !== null) {
          if (t.nextPage.endsWith(t.callNumber + 1)) {
            // We check that the next page corresponds to the current call number + 1 to avoid
            // loading the same elements that are already loaded (because of how the mugen scroll
            // seems to work). This solution works but can probably be made more elegant.
            t.callNumber++
            DatasetService.list(t, t.nextPage).then(function (response) {
              var res = response.data.results
              var item
              for (item in res) {
                t.listItems.push(res[item])
              }
              if (response.data.next !== null) {
                t.nextPage = response.data.next
              } else {
                t.nextPage = null
              }
            }).catch(function (error) {
              t.$store.commit('push', { msg: 'error when getting the list of datasets', color: 'error' })
              console.log('error ' + error + ' - refer to this file and line --->')
            })
          }
        }
        this.newElementsLoading = false
      },
    },
  }
</script>
